module.exports = __webpack_public_path__ + "img/logo-white.9591570.svg";